var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2277",
    "data-name": "Group 2277",
    transform: "translate(-668 -977)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_923",
    "data-name": "Rectangle 923",
    width: 30,
    height: 30,
    rx: 15,
    transform: "translate(668 977)",
    fill: "#fcefeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2276",
    "data-name": "Group 2276",
    transform: "translate(398.889 -340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M4,6.778A1.778,1.778,0,0,1,5.778,5H16.444a1.778,1.778,0,0,1,1.778,1.778V17.444a1.778,1.778,0,0,1-1.778,1.778H5.778A1.778,1.778,0,0,1,4,17.444Z",
    transform: "translate(273 1320.778)",
    fill: "none",
    stroke: "#a66416",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M16,3V6.556",
    transform: "translate(271.667 1321)",
    fill: "none",
    stroke: "#a66416",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M8,3V6.556",
    transform: "translate(272.556 1321)",
    fill: "none",
    stroke: "#a66416",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M4,11H18.222",
    transform: "translate(273 1320.111)",
    fill: "none",
    stroke: "#a66416",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M7,14h.012",
    transform: "translate(272.667 1319.778)",
    fill: "none",
    stroke: "#a66416",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M10.01,14h0",
    transform: "translate(272.332 1319.778)",
    fill: "none",
    stroke: "#a66416",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M13.01,14h0",
    transform: "translate(271.999 1319.778)",
    fill: "none",
    stroke: "#a66416",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M16.015,14h0",
    transform: "translate(271.665 1319.778)",
    fill: "none",
    stroke: "#a66416",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M13.015,17h0",
    transform: "translate(271.998 1319.444)",
    fill: "none",
    stroke: "#a66416",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M7.01,17h0",
    transform: "translate(272.666 1319.444)",
    fill: "none",
    stroke: "#a66416",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M10.01,17h0",
    transform: "translate(272.332 1319.444)",
    fill: "none",
    stroke: "#a66416",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.facf8ff3ac4d304d077c64fb37bbefde.svg";
export { ForwardRef as ReactComponent };